export const resourcesRouteNames = [
  'resourcesCaseStudies',
]
